import React from 'react';
import { useTranslate } from 'react-admin';

import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';

import AutocompleteArrayInputEx from 'components/_extensions/react-admin/ra-ui-materialui/src/input/AutocompleteArrayInputEx';
import { FormGroupGrid, GridForm, GridInput } from '../../../components/GridForm';
import { OrderedIdsInput, ReferenceOrderedIdsInput } from '../../../components/inputs';
import { serviceChoices } from '../../tasks/forms/inputs/ServiceInput';


const useStyles = makeStyles((theme) => ({
	noteRow: {
		display: 'flex',
		alignItems: 'center',
		color: theme.palette.text.secondary,
	},
	noteText: {
		marginLeft: theme.spacing(1),
	},
}));


export const TasksSettingsForm = (props) => {
	const classes = useStyles();
	const translate = useTranslate();

	return (
		<GridForm {...props}>
			<FormGroupGrid sm={6} title={translate('resources.company-users.fields.excluded_task_services')}>
				<GridInput
					xs={12}
					component={AutocompleteArrayInputEx}
					source="excluded_task_services"
					choices={serviceChoices}
					label=""
					helperText="tasks_settings.excluded_hint"
				/>
			</FormGroupGrid>
			<FormGroupGrid sm={6} title={translate('resources.company-users.fields.task_service_priorities')}>
				<GridInput
					xs={12}
					component={OrderedIdsInput}
					source="task_service_priorities"
					choices={serviceChoices}
					label={false}
					addItemLabel="tasks_settings.add_service_to_prioritize"
					helperText="tasks_settings.priorities_hint"
				/>
			</FormGroupGrid>
			<Grid item xs={12}>
				<div className={classes.noteRow}>
					<InfoOutlinedIcon fontSize="small" />
					<Typography variant="body2" className={classes.noteText}>
						{translate('tasks_settings.unspecified_note')}
					</Typography>
				</div>
			</Grid>
			<FormGroupGrid sm={6} title={translate('resources.company-users.fields.customer_priorities')}>
				<GridInput
					xs={12}
					component={ReferenceOrderedIdsInput}
					source="customer_priorities"
					reference="customer-companies"
					optionText="full_name"
					label={false}
					addItemLabel="tasks_settings.add_customer"
					helperText="tasks_settings.customers_hint"
				/>
			</FormGroupGrid>
		</GridForm>
	);
};
